var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero is-fullheight login",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-centered"},[_c('article',{staticClass:"card is-rounded"})])])])])
}]

export { render, staticRenderFns }